"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateLocation = exports.serializeLocation = void 0;
const serializeLocation = (item) => {
    const location = item.data.location;
    if (location) {
        return `Checked in at latitude: ${location.coords.latitude}, longitude: ${location.coords.longitude} at ${new Date(location.timestamp).toLocaleString()}`;
    }
    else {
        ("Not checked in.");
    }
    return item.data.location || "";
};
exports.serializeLocation = serializeLocation;
const validateLocation = (item) => {
    if (!item.required || item.data.location) {
        return { valid: true };
    }
    return { valid: false, error: { message: "Please complete check-in." } };
};
exports.validateLocation = validateLocation;
//# sourceMappingURL=location.js.map